import { useLocation } from '@reach/router';
import shuffle from 'lodash/shuffle';
import React from 'react';

import type { InternalHost } from '@xingternal/crate-xinglet';
import { useHost } from '@xingternal/crate-xinglet';

import { RecruiterCardsList } from './recruiter-cards-list';
import { CompanyRecruitersData } from './recruiters-data';

export type CompanyRecruitersDataType = {
  id: number;
  photoUrl: string;
  flagText: string;
  rating?: number;
  name: string;
  companyLogo?: string;
  jobTitle: string;
  insight: string;
  company?: string;
  profileUrl: string;
};

export const RecruiterCardsListContainer: React.FC = () => {
  // for testing purposes
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  let recruiters: CompanyRecruitersDataType[] = [];
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const host = useHost() as InternalHost;
  if (host.isServer) {
    recruiters =
      queryParams.get('allRecruiters') === 'true'
        ? CompanyRecruitersData
        : shuffle(CompanyRecruitersData).slice(0, 20);

    host.storeServerData?.('recruitersStartPage', () =>
      JSON.stringify(recruiters)
    );
  } else {
    recruiters = JSON.parse(
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      host.loadServerData?.('recruitersStartPage') as string
    );
  }

  return <RecruiterCardsList recruiters={recruiters} />;
};
